const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessoriesHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3597 2959",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M51.856,13.881c4.687,-1.051 498.856,-110.48 1168.163,302.665c347.209,-368.715 1007.691,-392.493 1318.66,-142.776l38.875,32.776c569.865,-283.614 970.761,-192.658 970.761,-192.658c0,0 -0.872,-0.012 -2.569,-0.006c0.578,0.002 0.871,0.006 0.871,0.006c0,0 225.958,669.558 -280.862,1332.937l278.458,319.708c15.396,17.675 7.804,44.925 -14.65,52.558l-338.429,115.104c-41.729,14.192 -63.979,58.504 -49.896,99.367l111.875,324.633c13.229,38.383 -17.087,77.783 -58.558,76.112l-292.688,-11.8c-72.204,-2.913 -132.371,53.412 -132.371,123.912l0,87.079c0,0 -1.151,0.625 -3.421,1.806c13.257,79.172 12.022,166.146 -12.075,190.243c-203.979,203.979 -751.067,232.562 -956.942,232.562c-203.58,0 -740.808,-27.95 -949.994,-225.807c-2.53,-2.384 -5.013,-4.793 -7.447,-7.227c-24.206,-24.206 -25.342,-111.856 -11.895,-191.312c-0.262,-0.176 -0.393,-0.266 -0.393,-0.266l0,-87.079c0,-70.5 -60.167,-126.825 -132.375,-123.912l-292.687,11.8c-41.471,1.671 -71.783,-37.729 -58.558,-76.112l111.875,-324.633c14.083,-40.862 -8.167,-85.175 -49.896,-99.367l-338.429,-115.104c-22.45,-7.633 -30.046,-34.883 -14.65,-52.558l278.458,-319.708c-506.821,-663.379 -280.862,-1332.937 -280.862,-1332.937c0,0 0.559,-0.007 1.652,-0.008l-0.034,0.008c0,0 0.306,-0.004 0.908,-0.006l-0.874,-0.001Z",
    style: {
      fill: "#afefd6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessoriesHover);
export default __webpack_public_path__ + "static/media/accessories-hover.3fabb65f746246c04325c59ebe431389.svg";
export { ForwardRef as ReactComponent };